import { useEffect, useState } from 'react';
import Text from '@sber-site/sbercraft-nova-kit/components/Text';
import RadioGroup from '../RadioGroup/RadioGroup';
import Textarea from '@sber-site/sbercraft-nova-kit/components/Textarea';
import Button from '@sber-site/sbercraft-nova-kit/components/Button';
import bem from 'bem-cn';
import { useStyles } from '../../../../LoaderContext';

import Icon from '@sber-site/sbercraft-nova-kit/components/Icon';
import { ReactComponent as CloseIcon } from '../../images/CloseIcon.svg';
import { cleanFeedbackMessage } from '../../utils/cleanFeedbackMessage';
import * as css from './Survery.css';
import SurverySuccess from './SurverySuccess';

import { sendToAnalytics } from '../../analytics/web-analytics';

const cn = bem('retention');

export default function Survery({ isSurveryShow, handleServeryShow, surveryData, closeRetention, eventLabelWithType }) {
    useStyles(css);
    useEffect(() => {
        sendToAnalytics('survey_show', eventLabelWithType);
    }, []);
    const options = surveryData?.points;
    const [checkedOption, setCheckedOption] = useState(options?.[0]?.value);
    const [textareaValue, setTextareaValue] = useState('');
    const [checkedValueIndex, setCheckedValueIndex] = useState(0);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    
    const handleChangeOption = (index: number) => {
        setCheckedValueIndex(index);
    };
    
    const showTextarea =
    checkedOption === options?.[options?.length - 1]?.value &&
    options?.[options?.length - 1]?.type === 'other';
    const textareaPlaceholder = options?.[options?.length - 1]?.placeholder || '';
    
    return (
        isSurveryShow && (
            <div className={cn('survery')()}>
            {!isButtonClicked ? (
                <>
                <div className={cn('survery-closeIcon')()}>
                <Icon
                onClick={() => {
                    sendToAnalytics('survey_close');
                    handleServeryShow(false);
                }}
                >
                <CloseIcon />
                </Icon>
                </div>
                <Text className={cn('survery-heading')()} size='md' bold={true}>
                {surveryData?.header}
                </Text>
                <RadioGroup
                handleChangeOption={handleChangeOption}
                checked={checkedOption}
                type='vertical'
                size='md'
                options={options}
                onChange={(value) => {
                    sendToAnalytics('survey_point_change', value);
                    setCheckedOption(value);
                }}
                />
                {showTextarea && (
                    <div className={cn('survery-textareaBlock')()}>
                    <Textarea
                    size='md'
                    maxLength='300'
                    className={cn('survery-textarea')()}
                    onChange={(value) => {
                        setTextareaValue(value);
                    }}
                    value={textareaValue}
                    placeholder={textareaPlaceholder}
                    />
                    <Text className={cn('survery-textarea-subtitle')()} size='sm'>
                    {`${textareaValue.length} / 300`}
                    </Text>
                    </div>
                )}
                <Button
                type='tertiary'
                size='sm'
                onClick={() => {
                    if (showTextarea) {
                        sendToAnalytics('survey_submit', `other_${cleanFeedbackMessage(textareaValue)}`);
                    } else {
                        sendToAnalytics("survey_submit", checkedOption);
                    }
                    setIsButtonClicked(true);
                    closeRetention();
                }}
                >
                Отправить
                </Button>
                </>
            ) : (
                <SurverySuccess
                surveryData={surveryData}
                index={checkedValueIndex}
                handleServeryShow={handleServeryShow}
                />
            )}
            </div>
        )
    );
}
